import { type DetailedHTMLProps, type FC, type ImgHTMLAttributes } from "react";

import styled from "@emotion/styled";

import removedLensIcon from "../../assets/lenses/removed-lens-icon.png";

// TODO: uncomment when we implement lens marketplace
// import { LENS_MARKETPLACE_SOURCE_NAME } from "../../lens-marketplace/constants";
// import { MarketplaceIcon } from "../../top-navigation/components/lens-marketplace-button/MarketplaceIcon";

// import { Visible } from "./Visible";

const defaultIconSize = 48;
const removedLensImage = removedLensIcon;

interface LensIconProps extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    size?: number;
    removed?: boolean;
    source?: string;
    badgeClassName?: string;
    badgeSizePx?: number;
    isOnPreview?: boolean;
}

// const defaultSize = 12;

export const LensIcon: FC<LensIconProps> = ({ size, src, removed, ...imgProps }) => {
    const iconSize = size ?? defaultIconSize;
    // const showMarketplaceIcon = source === LENS_MARKETPLACE_SOURCE_NAME;

    return (
        <>
            {/*<Visible when={showMarketplaceIcon}>*/}
            {/*    <OverlayIcon isOnPreview={isOnPreview} className={badgeClassName} sizePx={badgeSizePx} />*/}
            {/*</Visible>*/}
            <Icon {...imgProps} size={iconSize} src={removed ? removedLensImage : src} />
        </>
    );
};

const Icon = styled.img<{ size: number }>((props) => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
}));

// const OverlayIcon = styled(MarketplaceIcon)<{ isOnPreview: boolean }>`
//     border: 0.5px solid;
//     margin-top: 25px;
//     padding: 3px;
//     position: absolute;
//     z-index: 2;
//     transform: ${(props) => props.isOnPreview && "translate(45px, -25px)"};
// `;
